// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 14/11/2025
import { makeApiCall, makeFormApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/************************ GET SEARCH BUSINESS LOAN LIST START ****************** */
export const fetchSearchBusinessLoanList = (listData: any) => {
	const data = {
		SearchBusinessLoanListDataToken: listData,
	};
	const url = `${API_URL}getSearchForBusinessLoanListDetails`;
	return makeApiCall(url, data);
};
/************************ GET SEARCH BUSINESS LOAN LIST END ****************** */

/************************ GET SEARCH BUSINESS LOAN INFO START ****************** */
export const fetchBusinessLoanInfo = (listData: any) => {
	const data = {
		LoanInfoBasedOnMemeberLoanDataToken: listData,
	};
	// const url = `${API_URL}getLoanInfoBasedOnMemeberLoanIndexDetails`;
	const url = `${API_URL}getLoanInfoBasedOnBusinessLoanIndexDetails`;

	return makeApiCall(url, data);
};
/************************ GET SEARCH BUSINESS LOAN INFO END ****************** */

/************************ UPDATE INTEREST WAIVER START****************** */
export const businessCollectionUpdateAPI = (listData: any) => {
	const data = {
		UpdateMemberListData: listData,
	};
	const url = `${API_URL}updateMemberLoanPaidForSelectedMembers`;
	return makeApiCall(url, data);
};
/************************ UPDATE INTEREST WAIVER END ****************** */

/************************ BUSINESS DEATH UPDATE START ****************** */
export const businessDeathUpdateAPI = (listData: any) => {
	const data = {
		UpdateBusinessDeathData: listData,
	};
	const url = `${API_URL}updateBusinessDeathDetails`;
	return makeApiCall(url, data);
};
/************************ BUSINESS DEATH UPDATE END ****************** */

/************************  INTEREST WAIVER UPDATE START ****************** */
export const businessInterestWaiverUpdateAPI = (listData: any) => {
	const data = {
		UpdateInterestWaiverData: listData,
	};
	const url = `${API_URL}updateInterestWaiverDetails`;
	return makeApiCall(url, data);
};
/************************  INTEREST WAIVER UPDATE END ****************** */

/************************ GET BUSINESS LOAN PAID START ****************** */
export const businessCollectionFetchAPI = (listData: any) => {
	const data = {
		FetchMemberCollectionData: listData,
	};
	const url = `${API_URL}fetchMemberLoanPaidForSelectedMembersDetails`;
	return makeApiCall(url, data);
};
/************************ GET BUSINESS LOAN PAID END ****************** */

/************************ GET BUSINESS WALLET START ****************** */
export const businessWalletFetchAPI = (listData: any) => {
	const data = {
		FetchMemberWalletData: listData,
	};
	const url = `${API_URL}fetchMemberWalletForSelectedMembersDetails`;
	return makeApiCall(url, data);
};
/************************ GET BUSINESS WALLET END ****************** */

/************************ GET BUSINESS QR START ****************** */
export const businessQrFetchAPI = (listData: any) => {
	const data = {
		FetchMemberQrData: listData,
	};
	const url = `${API_URL}fetchMemberQrForSelectedMembersDetails`;
	return makeApiCall(url, data);
};
/************************ GET BUSINESS QR END ****************** */

/************************ GET BUSINESS REPAYMENT START ****************** */
export const businessRepaymentFetchAPI = (listData: any) => {
	const data = {
		FetchMemberRepaymentData: listData,
	};
	const url = `${API_URL}fetchMemberRepaymentForSelectedMember`;
	return makeApiCall(url, data);
};
/************************ GET BUSINESS REPAYMENT END ****************** */

/************************ REVERT BUSINESS COLLECTION START ****************** */
export const businessWalletRevertAPI = (listData: any) => {
	const data = {
		RevertMemberWalletData: listData,
	};
	const url = `${API_URL}revertMemberWalletForSelectedMembersDetails`;
	return makeApiCall(url, data);
};
/************************ REVERT BUSINESS COLLECTION END ****************** */

/************************ REVERT BUSINESS COLLECTION START ****************** */
export const businessCollectionRevertAPI = (listData: any, serviceName: any) => {
	const data = {
		RevertMemberListData: listData,
	};
	const url = `${API_URL}${serviceName}`;
	return makeApiCall(url, data);
};
/************************ REVERT BUSINESS COLLECTION END ****************** */

/************************ BUSINESS LOAN CARD PDF START ****************** */
export const getBusinessLoanCardPDF = (listData: any) => {
	const queryParams = new URLSearchParams();
	queryParams.append('BusinessLoanCardPDFToken', listData);
	const url = `${API_URL}tcpdf/pdf/LoanCardPDF.php`;
	return makeFormApiCall(url, queryParams);
};
/************************ BUSINESS LOAN CARD PDF END ****************** */

/************************ BUSINESS REPAYMENT PDF START ****************** */
export const getBusinessRepaymentPDF = (listData: any) => {
	const queryParams = new URLSearchParams();
	queryParams.append('MemberRepaymentPDFToken', listData);
	const url = `${API_URL}tcpdf/pdf/MemberRepaymentPDF.php`;
	return makeFormApiCall(url, queryParams);
};
/************************ BUSINESS REPAYMENT PDF END ****************** */

/************************ BUSINESS LOANCARD REPORT START ****************** */
export const geBusinessLoanCardReport = (listData: any) => {
	const queryParams = new URLSearchParams();
	queryParams.append('LoanCardReportToken', listData);
	const url = `${API_URL}Excel/LoanCardReportWithToken.php`;
	return makeFormApiCall(url, queryParams);
};
/************************ BUSINESS LOAN CARD REPORT END ****************** */

/************************ BUSINESS LOAN COLLECTION APPROVAL START ****************** */
export const businessLoanCollectionApprovalAPI = (listData: any) => {
	const data = {
		MemberLoanCollectionApprovalData: listData,
	};
	const url = `${API_URL}memberLoanCollectionApproval`;
	return makeApiCall(url, data);
};
/************************ BUSINESS LOAN COLLECTION APPROVAL END ****************** */

/************************ BUSINESS LOAN COLLECTION APPROVAL START ****************** */
export const businessWalletAddAPI = (Data: any) => {
	const data = {
		AddAmountToWalletToken: Data,
	};
	const url = `${API_URL}addAmountToWallet`;
	return makeApiCall(url, data);
};
/************************ BUSINESS LOAN COLLECTION APPROVAL END ****************** */

/************************ BUSINESS LOAN COLLECTION ARREAR ENTRY START ****************** */
export const businessLoanPaidEntry = (Data: any) => {
	const data = {
		UpdateLoanPaidToken: Data,
	};
	// const url = `${API_URL}updateLoanPaid`;
	const url = `${API_URL}updateBusinessLoanPaid`;

	return makeApiCall(url, data);
};
/************************ BUSINESS LOAN COLLECTION ARREAR ENTRY END ****************** */

/************************ BUSINESS LOAN COLLECTION APPROVAL START ****************** */
export const businessArrearLoanPaidEntry = (Data: any) => {
	const data = {
		UpdateArrearLoanPaidTokenData: Data,
	};
	// const url = `${API_URL}updateBusinessArrearLoanPaidDetails`;
	const url = `${API_URL}updateBusinessArrearLoanPaidDetailsTwo`;

	return makeApiCall(url, data);
};
/************************ BUSINESS LOAN COLLECTION APPROVAL END ****************** */
